




import { defineComponent, onMounted } from "@nuxtjs/composition-api";
import HomePage from './Home.vue';
import { useUiState } from "~/composables";

export default defineComponent({
  name: "LoginPage",
  components: {
    HomePage
  },
  setup() {
    const { toggleLoginModal } = useUiState();
    
    onMounted(() => {
      toggleLoginModal();
    });
    
    return {};
  }
});
